import React, { Component } from "react";
import moment from "moment";
import { Spin } from "antd";
// 组件
import NoData from "@/components/common/no_data";
// 接口以及调用接口方法
import { successRateQry } from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";
import Echarts from "echarts";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
// 图片
import legend1 from "@/assets/img/displayBoard/ds1.svg";
@connect((state) => state)
class PeopleRateBar extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.chartId = this.props.chartId ? this.props.chartId : ""; // 设置柱状图ID
    this.state = {
      showSping: true, // loading加载是否显示：true，显示，false，不显示
      noData: false, // 是否有数据
      param: [],
      barData: [],
    };
  }

  // 父组件修改param时执行
  componentWillReceiveProps(nextProps) {
   
    this.setState(
      {
        showSping: true,
        param: nextProps.param == null ? [] : nextProps.param,
      },
      () => {
        this.getSuccessRate();
      },
    );
  }

  // 获取数据
  getSuccessRate() {
    
    if (this.state.param && this.state.param != null) 
    {
      this.setState({
        barData:!this.state.param || this.state.param == null ? [] : this.state.param,
        showSping: false,
        noData: false,
      },
      () => {
        this.renderChart();
      }
      )
    } else {
      this.setState({
        noData: true,
      });
    }
  }

  componentDidMount() {
    this.getSuccessRate();
  }

  renderChart() {
    if (!this.state.barData || this.state.barData == null)
    {
      this.setState({
        barData:[]
      })
    }
    window.removeEventListener("resize", () => {});
    var { barData } = this.state;
    // 假数据
    const xAxisData = [];
    const successData = [];
    const successRateData = [];
    // const successListNoMap = [];
    const allData = [];
    // 获取数据
    if (!barData || barData == null || barData instanceof Map)
    {
      barData = [];
    }
    else {
      try {
        console.log(barData)
        barData.map((item) => {
          xAxisData.push(item.ticketPriorityName);
          successData.push({
            value: item.totalHour,
            info: {
              totalOrder: item.totalHour,
              successRate: item.totalHour,
            },
          });
          successRateData.push(item.totalHour);
          allData.push(item.totalHour);
          return true;
        });
      } catch (e)
      {}
    }
    allData.sort((a, b) => Number(b) - Number(a));
    let maxVal = 0;
    if (allData.length > 0) {
      maxVal = Math.ceil(Number(allData[0]) / 10) * 10;
    }
    const myChart = Echarts.init(document.getElementById("peopleRateBar"));
    const option = {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          crossStyle: {
            color: "#999",
          },
        },
        backgroundColor: "rgba(0,0,0,.5)",
        show: true,
        formatter: (params) => {
          let str = "";
          if (params[0].axisValue) {
            
            return str;
          }
        },
      },
      color: ["#EB7F66", "#75DDB2"],
      legend: {
        selectedMode: false,
        textStyle: {
          padding: [10, 0],
        },
        itemGap: 15,
        itemWidth: 21,
        itemHeight: 8,
        data: [
        ],
        top: 0,
      },
      xAxis: [
        {
          type: "category",
          data: xAxisData,
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "rgba(0,0,0,.45)",
            },
          },
          axisLabel: {
            interval: 0,
            margin: 10,
            textStyle: {
              color: "rgba(0,0,0,.45)",
            },
          },
        },

        {
          type: "category",
          data: xAxisData,
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
        },
      ],
      grid: {
        left: "65px",
        right: "50px",
        bottom: "20px",
      },
      yAxis: [
        {
          type: "value",
          name: "（时）",
          axisLine: { show: false },
          axisTick: { show: false },
          min: 0,
          max: maxVal,
          interval: Math.ceil(maxVal / 10),
          axisLabel: {
            formatter: "{value}",
          },
          nameTextStyle: {
            padding: [0, 25, 10, 0],
          },
        },
        {
          type: "value",
          name: "",
          axisLine: { show: false },
          axisTick: { show: false },
          min: 0,
          max: 100,
          interval: 10,
          axisLabel: {
            formatter: "{value}%",
          },
        },
      ],
      series: [
        
        {
          name: "成功订单",
          type: "bar",
          barWidth: 37,
          yAxisIndex: 0,
          stack: "1",
          barGap: "-100%",
          data: successData,
        },
      ],
    };
    myChart.clear();
    myChart.setOption(option);
    window.addEventListener("resize", () => {
      myChart.resize();
    });
  }

  render() {
    const content = (
      <Spin tip="加载中..." spinning={this.state.showSping}>
        <div className="exception-line-chart">
          <div className="line" id="peopleRateBar"></div>
        </div>
        {this.state.noData ? (
          <div className="no_data_com no_data_line">
            <NoData />
          </div>
        ) : null}
      </Spin>
    );

    return content;
  }
}

export default injectIntl(PeopleRateBar);



// WEBPACK FOOTER //
// ./src/AntD/pages/displayBoard/peopleRateBar.js